import type * as SchemaTypes from '../types';

import type { WebPagePathDataFragment } from './WebPagePathData';
import { gql } from '@apollo/client';
import { WebPagePathDataFragmentDoc } from './WebPagePathData';
export type WebPageEndpointSpecsFragment = (
  { __typename: 'WebPageEndpoint' }
  & Pick<SchemaTypes.WebPageEndpoint, 'id' | 'pathname' | 'title' | 'webPageId'>
  & { websiteModule: (
    { __typename: 'WebsiteModule' }
    & Pick<SchemaTypes.WebsiteModule, 'id' | 'displayName'>
  ), webpagePaths: Array<(
    { __typename: 'WebPagePath' }
    & WebPagePathDataFragment
  )> }
);

export const WebPageEndpointSpecsFragmentDoc = /*#__PURE__*/ gql`
    fragment WebPageEndpointSpecs on WebPageEndpoint {
  id
  pathname
  title
  websiteModule {
    id
    displayName
  }
  webPageId
  webpagePaths {
    ...WebPagePathData
  }
}
    `;